const { wlSiteSettings, wlApiSettings } = window;

export const SITE_URL = wlSiteSettings ? wlSiteSettings.url : '';
export const API_NAMESPACE = 'wlion';
export const API_VERSION = 'v1';
export const API_URL = wlApiSettings ? wlApiSettings.url : '';
export const API_WP_REST_NONCE = wlApiSettings
  ? wlApiSettings.wp_rest_nonce
  : '';
export const API_WL_SITE_NONCE = wlApiSettings
  ? wlApiSettings.wl_site_nonce
  : '';
export const API_WP_JSON = wlApiSettings ? wlApiSettings.wp_json : '';
export const { ENV } = window;
